import colours, { palette } from '~/utils/colours';

export const bootstrapStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: '#fff',
    color: state.isFocused ? palette.tealishTwo : palette.brownishGrey,
    fontWeight: 'normal',
    fontSize: 13,
    height: 40,
    border: `1px solid ${
      state.isFocused ? palette.tealishTwo : palette.veryLightPinkThree
    }`,
    borderRadius: 5,
    boxShadow: 'none',

    '&:hover': {},
  }),

  menu: (base) => ({
    ...base,
    marginTop: 0,
    border: 'none',
    borderRadius: 5,
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
  }),

  container: (base) => ({
    ...base,
    paddingLeft: '3px',
  }),

  option: (base, state) => ({
    ...base,
    backgroundColor:
      state.isFocused && !state.isSelected
        ? colours.greyLightAlt
        : base.backgroundColor,
  }),
};
